"use strict";

var _templateObject, _templateObject2, _templateObject3;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.KameleoonVisitorCodeManager = void 0;
var _constants = require("./constants"),
  _javascriptSdkCore = require("@kameleoon/javascript-sdk-core");
var VisitorCodeManager = /*#__PURE__*/function () {
  function VisitorCodeManager() {
    _classCallCheck(this, VisitorCodeManager);
  }
  return _createClass(VisitorCodeManager, [{
    key: "getData",
    value: function getData(a) {
      _javascriptSdkCore.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: VisitorCodeManager.getData(key: ", ")"])), a);
      var b = document.cookie;
      var c = null;
      return b && (c = _javascriptSdkCore.KameleoonUtils.getCookieValue(b, a)), _javascriptSdkCore.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: VisitorCodeManager.getData(key: ", ") -> (visitorCode: ", ")"])), a, c), c;
    }
  }, {
    key: "setData",
    value: function setData(a) {
      var b = a.visitorCode,
        c = a.domain,
        d = a.maxAge,
        e = a.key,
        f = a.path;
      var g = this.getResultCookie({
        domain: c,
        visitorCode: b,
        key: e,
        maxAge: d,
        path: f
      });
      document.cookie = g, _javascriptSdkCore.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Cookie ", " was added for visitor ", ""])), g, b);
    }
  }, {
    key: "getResultCookie",
    value: function getResultCookie(a) {
      var b = a.domain,
        c = a.visitorCode,
        d = a.maxAge,
        e = a.key,
        f = a.path;
      var g = [e + _constants.CookieParameter.KeyValueDelimiter + c, _constants.CookieParameter.MaxAge + _constants.CookieParameter.KeyValueDelimiter + d, _constants.CookieParameter.Path + _constants.CookieParameter.KeyValueDelimiter + f];
      return b && g.push(_constants.CookieParameter.Domain + _constants.CookieParameter.KeyValueDelimiter + b), g.join(_constants.CookieParameter.PairsDelimiter);
    }
  }]);
}();
exports.KameleoonVisitorCodeManager = VisitorCodeManager;